import React from 'react';

/**
 *
 * @param {string} type - input type
 * @param {string} label - label text for input
 * @param {string} name - name attribute
 * @param {string} id - id attribute
 * @param value - input value
 * @param {Function} handleChange - change event handler
 * @param {string} labelClassName - CSS Classses for <label>
 * @param {string} inputClassName - CSS Classses for <input/>
 * @returns A <label> + <input>
 */
const Input = ({
  type,
  label,
  name,
  id,
  value,
  handleChange,
  labelClassName,
  inputClassName,
  error,
}) => (
  <>
    <label htmlFor={id} className={labelClassName}>
      {label}
    </label>
    <input
      type={type}
      name={name}
      id={id}
      value={value}
      onChange={handleChange}
      className={inputClassName}
    />
    {error && <p className="cef-form__error">{error}</p>}
  </>
);

export default Input;
